import React from "react"

const SectionHelp = () => (
  <section className="capstrip sub-cap2" id="team-help">
    <div className="wrap">
      <h2>How we help TEAM participants</h2>
      <div className="caps">
        <div className="cap c1">
          <div className="pic">
            <svg viewBox="0 0 32 32" aria-hidden="true">
              <polyline
                points="3,24 11,17 17,20 29,7"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                points="22,7 29,7 29,14"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div>
            <b>Predictive analytics</b>
            <span>See each category against target before CMS reconciles.</span>
          </div>
        </div>
        <div className="cap c2">
          <div className="pic">
            <svg viewBox="0 0 32 32" aria-hidden="true">
              <circle
                cx="14"
                cy="14"
                r="8.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
              />
              <line
                x1="20.5"
                y1="20.5"
                x2="28"
                y2="28"
                stroke="currentColor"
                strokeWidth="2.8"
                strokeLinecap="round"
              />
              <path
                d="M10.5 14.5l2.5 2.5 4.5-5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div>
            <b>Actionable opportunities</b>
            <span>
              Savings sized in dollars by surgeon and post-acute provider.
            </span>
          </div>
        </div>
        <div className="cap c3">
          <div className="pic">
            <svg viewBox="0 0 32 32" aria-hidden="true">
              <path
                d="M5 7h22v14H14l-6 5v-5H5z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                strokeLinejoin="round"
              />
              <circle cx="11" cy="14" r="1.7" fill="currentColor" />
              <circle cx="16" cy="14" r="1.7" fill="currentColor" />
              <circle cx="21" cy="14" r="1.7" fill="currentColor" />
            </svg>
          </div>
          <div>
            <b>Sid, our AI analyst</b>
            <span>Answers TEAM cost questions in plain language.</span>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default SectionHelp
